module.exports = __webpack_public_path__ + "static/calle02-24a51d53230c9011ee51262fe8cebb11.jpg";